$(document).ready(function () {
  var getwidnowwidth = $(window).width();
  if (getwidnowwidth < 1440) {
    new Swiper(".ingredients_slide_block", {
      navigation: {
        nextEl: ".ingredient-slide-button-next",
        prevEl: ".ingredient-slide-button-prev",
      },
      loop: false,
      pagination: {
        el: ".ingredient-swiper-pagination",
        clickable: true,
      },
      slidesPerView: 3,
      paginationClickable: true,
      spaceBetween: 10,
      breakpoints: {
        1200: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 1,
        },
      },
    });
  } else {
    var len = $(".ingredients_slider_col").length;
    if (len > 4) {
      new Swiper(".ingredients_slide_block", {
        navigation: {
          nextEl: ".ingredient-slide-button-next",
          prevEl: ".ingredient-slide-button-prev",
        },
        pagination: {
          el: ".ingredient-swiper-pagination",
          clickable: true,
        },
        loop: false,
        slidesPerView: 5,
        paginationClickable: true,
        spaceBetween: 10,
        breakpoints: {
          1200: {
            slidesPerView: 3,
          },
          767: {
            slidesPerView: 1,
          },
        },
      });
    } else {
      $(".ingredients_slider").addClass("ingredients_row");
      $(".ingredients_slide_block").addClass("swiper-arrow-hide");
    }
  }

  var len_slider = $(".ingredients_slider .ingredients_slider_col").length;
  if (len_slider <= 4) {
    // $(".ingredients_sec .swiper-arrow").hide();
  }

  if (window.innerWidth <= 767) {
    if (len_slider <= 3) {
      console.log("aaa");
      $(".ingredients_sec .swiper-arrow").show();
    } else {
      console.log("yyy");
    }
  }
});
